import { AnyAction } from 'redux';

interface Task {
    loading: boolean;
}

const initialState: Task = {
    loading: false,
};
export const CreateTask = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
